<script>
    import { onMount } from "svelte";
    import Cinema from "../components/Cinema.svelte";

    let { data } = $props();
    const {
        dreson: contentDresonRule,
        headline,
        recommendations,
        tracking,
        additionalClickTracking,
        metaData,
        featuresState,
        backgroundColor,
        hasPersonalisedRecommendations = false,
    } = data;

    let index = $state("0");
    let cinemaInjectionContainerWidth = $state(1000);
    let featureIndex = $state("99");
    let additionalTrackingLabels = $state(null);
    let cinemaContainer;
    let additionalNextPiTrackingLabels = $state(null);
    let mountSuccess;
    let cinemaContainerMounted = new Promise((resolve) => {
        mountSuccess = resolve;
    });

    onMount(() => {
        featureIndex = cinemaContainer?.parentElement?.dataset?.featureOrder || "99";
        additionalTrackingLabels = JSON.parse(cinemaContainer?.parentElement?.dataset?.featureTrackingLabels || null);
        additionalNextPiTrackingLabels = JSON.parse(cinemaContainer?.parentElement?.dataset?.nextPiTrackingLabels || null);
        cinemaInjectionContainerWidth = parseInt(cinemaContainer?.offsetWidth) || 1000;
        mountSuccess();
    });
</script>

<div bind:this={cinemaContainer}>
    <div class="reco_entry_page_cinema_wrapper" style:background-color={backgroundColor}>
        <Cinema
            {headline}
            {recommendations}
            {tracking}
            {featureIndex}
            {additionalClickTracking}
            {featuresState}
            {cinemaInjectionContainerWidth}
            cinemaIndex={index}
            cinemaMeta={metaData}
            {additionalNextPiTrackingLabels}
            {additionalTrackingLabels}
            site="reco_entryPage"
            {contentDresonRule}
            personalisedUser={hasPersonalisedRecommendations}
            {cinemaContainerMounted}
        />
    </div>
</div>

<style lang="scss">
    .reco_entry_page_cinema_wrapper {
        min-height: 360px;
        max-height: 672px;
        position: relative;
    }
</style>
